module.exports = __webpack_public_path__ + "media/entities/1016-a3d71d0e.png";